/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSavePreviousSession = () =>
  useMutation({
    mutationKey: ["savePreviousSession"],
    mutationFn: previousData => {
      let api__data = {
        reportDate : previousData.reportDate,
        regionId : previousData.regionId,
        productLineId: previousData.productLineId,
        title: previousData.title,
        headerImagePath: previousData.headerImagePath,
        imagePath: previousData.imagePath,
        content: previousData.content,
        id: previousData.id
      }
      return service.savePreviousSession(api__data)
    },
  });

export default useSavePreviousSession;
